import { Injectable, inject } from '@angular/core';
import { PublicFaqPageApiService } from '../api/services/public-faq-page-api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { PublicFaqCategory } from '../models/public-faq-category';
import { CollectionRequestBuilder } from '@web/common';
import { PublicFaqQuestion } from '../models/public-faq-question';

@Injectable({
  providedIn: 'root',
})
export class PublicFaqPageDataSourceService {
  private readonly faqPageApi = inject(PublicFaqPageApiService);
  private readonly collectionBuilder = inject(CollectionRequestBuilder);

  public fetchCategories(): Observable<PublicFaqCategory[]> {
    return this.faqPageApi
      .fetchCollection(this.collectionBuilder.disablePagination().build())
      .pipe(
        map((response) =>
          response.items.map(
            (item) =>
              new PublicFaqCategory({
                id: item.id,
                name: item.name,
                slug: item.slug,
                questions: item.questions.map(
                  (question) =>
                    new PublicFaqQuestion({
                      id: question.id,
                      name: question.name,
                      content: question.content,
                    }),
                ),
              }),
          ),
        ),
        catchError(() => of([])),
      );
  }
}
